import { Navigate, Route, Routes } from "react-router-dom"
import { Casca } from "./casca/Casca"
import { usarSessao } from "./sessao/Sessao"
import { Login } from "./telas/Login"
import { Projetos } from "./telas/Projetos"
import { Projeto } from "./telas/Projeto"
import { Cadastros } from "./telas/cadastros/Cadastros"
import { Pinout } from "./telas/Pinout"
import { PinoutGrafico } from "./telas/pinout/grafico/PinoutGrafico"
import { Modelos } from "./telas/modelos/Modelos"
import { Checklist } from "./telas/checklist/Checklist"
import { VinculosDeSistema } from "./telas/sistemas/VinculosDeSistema"
import { Conteudo } from "./telas/conteudo/Conteudo"
import { Relatorios } from "./telas/relatorios/Relatorios"
import { ConversasDaIA } from "./telas/relatorios/ConversasDaIA"
import { CadastrosDeConteudo } from "./telas/cadastros-conteudo/CadastrosDeConteudo"
import { TabelasDeReferencia } from "./telas/referencia/TabelasDeReferencia"
import { Torques } from "./telas/outros/Torques"
import { AcervoDeTorques } from "./telas/outros/AcervoDeTorques"
import { RelesFusiveis } from "./telas/outros/RelesFusiveis"
import { TabelasDeValores } from "./telas/outros/TabelasDeValores"
import { Planos } from "./telas/outros/Planos"
import { Usuarios } from "./telas/usuarios/Usuarios"
import { Clientes } from "./telas/clientes/Clientes"
import { Licencas } from "./telas/clientes/Licencas"
import { Diagramas } from "./telas/diagramas/Diagramas"
import { EditorDoComponente } from "./telas/diagramas/EditorDoComponente"
import { MontarDiagrama } from "./telas/diagramas/MontarDiagrama"
import { DadosDoProjeto } from "./telas/projeto/DadosDoProjeto"
import { Importacao } from "./telas/importacao/Importacao"
import { FilaDeRevisao } from "./telas/revisao/FilaDeRevisao"
import { CatalogosGlobais } from "./telas/catalogos/CatalogosGlobais"
import { Cobertura } from "@/telas/cobertura/Cobertura"
import { Feedback } from "@/telas/feedback/Feedback"
import { Solicitacoes } from "@/telas/feedback/Solicitacoes"
import { DesenhosInternos } from "@/telas/catalogos/DesenhosInternos"
import { CoresDeFuncao } from "./telas/catalogos/CoresDeFuncao"
import { CatalogosDoDiagrama } from "@/telas/catalogos/CatalogosDoDiagrama"
import { ManutencaoFipe } from "@/telas/referencia/ManutencaoFipe"
import { ConectoresNomeSistema } from "@/telas/outros/ConectoresNomeSistema"
import { ComponentesExportar } from "@/telas/outros/ComponentesExportar"
import { ImportarAbrangencia } from "@/telas/referencia/ImportarAbrangencia"
import { CaixasDeFusiveis } from "./telas/fusiveis/CaixasDeFusiveis"
import { Correias } from "./telas/correias/Correias"

export function App() {
  const { autenticado } = usarSessao()

  if (!autenticado) {
    return (
      <Routes>
        <Route path="/entrar" element={<Login />} />
        <Route path="*" element={<Navigate to="/entrar" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route element={<Casca />}>
        {/* Não há tela de início: o sistema abre em Projetos, que é por onde todo trabalho começa. */}
        <Route path="/" element={<Navigate to="/projetos" replace />} />
        <Route path="/projetos" element={<Projetos />} />
        <Route path="/revisao" element={<FilaDeRevisao />} />
          <Route path="/conteudo" element={<Conteudo />} />
          <Route path="/relatorios" element={<Relatorios />} />
          <Route path="/conversas-ia" element={<ConversasDaIA />} />
          <Route path="/cadastros-conteudo" element={<CadastrosDeConteudo />} />
          {/* As tres compartilham a tela; o caminho escolhe qual abre. */}
          <Route path="/torques" element={<Torques />} />
          <Route path="/acervo-torques" element={<AcervoDeTorques />} />
          <Route path="/reles" element={<RelesFusiveis />} />
          <Route path="/valores" element={<TabelasDeValores />} />
          <Route path="/planos" element={<Planos />} />
          <Route path="/usuarios" element={<Usuarios />} />
          <Route path="/clientes" element={<Clientes />} />
          <Route path="/licencas" element={<Licencas />} />
          <Route path="/fipe" element={<TabelasDeReferencia />} />
          <Route path="/fraga" element={<TabelasDeReferencia />} />
          <Route path="/estudo-mercado" element={<TabelasDeReferencia />} />
        <Route path="/catalogos" element={<CatalogosGlobais />} />
        <Route path="/cores-funcao" element={<CoresDeFuncao />} />
        <Route path="/catalogos-diagrama" element={<CatalogosDoDiagrama />} />
        <Route path="/fipe-manutencao" element={<ManutencaoFipe />} />
        <Route path="/conectores-sistema" element={<ConectoresNomeSistema />} />
        <Route path="/componentes" element={<ComponentesExportar />} />
        <Route path="/abrangencia-importar" element={<ImportarAbrangencia />} />
        <Route path="/desenhos-internos" element={<DesenhosInternos />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/solicitacoes" element={<Solicitacoes />} />
        <Route path="/cobertura" element={<Cobertura />} />
        <Route path="/correias" element={<Correias />} />
        <Route path="/projetos/:projetoId" element={<Projeto />}>
          {/* Abre no pinout: é a primeira aba e é para onde a lista de projetos leva. */}
          <Route index element={<Navigate to="pinout" replace />} />
          <Route path="cadastros" element={<Cadastros />} />
          <Route path="pinout" element={<Pinout modo="externo" />} />
          <Route path="pinout-interno" element={<Pinout modo="interno" />} />
          <Route path="grafico" element={<PinoutGrafico />} />
          <Route path="sistemas" element={<VinculosDeSistema />} />
          <Route path="modelos" element={<Modelos />} />
          <Route path="checklist" element={<Checklist />} />
          <Route path="diagramas" element={<Diagramas />} />
          <Route path="diagramas/:diagramaId/componentes/:componenteId"
                 element={<EditorDoComponente />} />
          <Route path="diagramas/:diagramaId/montar" element={<MontarDiagrama />} />
          <Route path="projeto" element={<DadosDoProjeto />} />
          <Route path="importar" element={<Importacao />} />
          <Route path="fusiveis" element={<CaixasDeFusiveis />} />
          {/* Tela que saiu (Comparar, Catálogo) ou endereço errado: volta ao pinout, em
              vez de deixar a área embaixo das abas em branco. */}
          <Route path="*" element={<Navigate to="pinout" replace />} />
        </Route>
        <Route path="/entrar" element={<Navigate to="/projetos" replace />} />
        <Route path="*" element={<Navigate to="/projetos" replace />} />
      </Route>
    </Routes>
  )
}
